/**
 * ScriptEditorTest — Temporary test page for UnifiedStepEditor.
 * Renders the editor with hardcoded Khan Login steps.
 * Route: /scripts/test-editor
 */

import React, { useState } from 'react';
import { Box, Typography, Paper, Chip } from '@mui/material';
import { UnifiedStepEditor } from '../components/UnifiedStepEditor';

const KHAN_LOGIN_STEPS = [
  {
    stepNumber: 1,
    type: 'action',
    name: 'Navigate to Khan Academy',
    inputData: { action: 'navigate', url: 'https://www.khanacademy.org/login', timeout: 10000 },
  },
  {
    stepNumber: 2,
    type: 'wait',
    name: 'Wait for login form',
    inputData: { waitType: 'selector', selector: '#uid-identifier-input', timeout: 5000 },
  },
  {
    stepNumber: 3,
    type: 'action',
    name: 'Enter email/username',
    inputData: { action: 'type', selector: '#uid-identifier-input', text: '{{credential.username}}', clearFirst: true, timeout: 3000 },
  },
  {
    stepNumber: 4,
    type: 'action',
    name: 'Click Continue button',
    inputData: { action: 'click', selector: 'button[data-test-id="identifier-submit"]', timeout: 3000 },
  },
  {
    stepNumber: 5,
    type: 'wait',
    name: 'Wait for password field',
    inputData: { waitType: 'selector', selector: '#uid-password-input', timeout: 5000 },
  },
  {
    stepNumber: 6,
    type: 'action',
    name: 'Enter password',
    inputData: { action: 'type', selector: '#uid-password-input', text: '{{credential.password}}', clearFirst: true, timeout: 3000 },
  },
  {
    stepNumber: 7,
    type: 'assertion',
    name: 'Verify login success',
    inputData: { assertionType: 'element', selector: '[data-test-id="user-menu"]', exists: true, timeout: 10000 },
  },
];

const ScriptEditorTest = () => {
  const [steps, setSteps] = useState(KHAN_LOGIN_STEPS);

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Typography variant="h5" fontWeight={700}>
          Unified Step Editor
        </Typography>
        <Chip label="TEST PAGE" color="warning" size="small" sx={{ fontWeight: 700 }} />
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Rendering UnifiedStepEditor with hardcoded Khan Academy Login steps in controlled mode.
      </Typography>

      <Paper elevation={2} sx={{ height: 'calc(100vh - 220px)', overflow: 'hidden' }}>
        <UnifiedStepEditor
          steps={steps}
          onStepsChange={setSteps}
          executionMode="frontend"
        />
      </Paper>
    </Box>
  );
};

export default ScriptEditorTest;
